<template>
<div id="is-show-navbar">
    <router-view></router-view>
</div>
</template>

<script>

export default {
    mounted() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
    },
};
</script>

